import sound from './breathe.wav';export default sound;